import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();



function add(role_permission) {
  
  console.log(role_permission);
  const payload = jsona.serialize({
    stuff: role_permission,
    includeNames: null
  });
  console.log(payload);
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.post(`${url}/role_permission`, payload, options)
    .then(response => {
      //return jsona.deserialize(response.data);
      return response.data;
    });
}

function destroy(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.delete(`${url}/role_permission/${id['id']}/${id['model_id']}`, options);
}





export default {
  add,
  destroy
};

